/*
 * @Author: your name
 * @Date: 2021-07-31 14:45:54
 * @LastEditTime: 2023-10-26 17:33:59
 * @LastEditors: bobo 350910378@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \k-gantt\src\render.js
 */
import {
    $,
    createSVG
} from './svg_utils';
import date_utils from './date_utils';
import {BsyUtils} from "../../../../utils/Utils";

const month_names = {
    en_us: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],

    zh_cn: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
    ],
    zh_tw: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
    ]
};

const quarterly_names = {
    en_us: ['Q1', 'Q2', 'Q3', 'Q4'],
    zh_cn: ['一季度', '二季度', '三季度', '四季度'],
    zh_tw: ['一季度', '二季度', '三季度', '四季度']
};

const weeks = {
    en_us: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],
    zh_cn: ['日', '一', '二', '三', '四', '五', '六'],
    zh_tw: ['日', '一', '二', '三', '四', '五', '六']
};

const am = {
    en_us: 'AM',
    zh_cn: '上午',
    zh_tw: '上午'
};

const pm = {
    en_us: 'PM',
    zh_cn: '下午',
    zh_tw: '下午'
};

const H1 = {
    en_us: 'H1',
    zh_cn: '上半年',
    zh_tw: '上半年'
};

const H2 = {
    en_us: 'H2',
    zh_cn: '下半年',
    zh_tw: '下半年'
};

const lang = window.localStorage.getItem("i18nextLng");

export default class render {
    constructor(gantt) {
        this.gantt = gantt;
    }

    render(x, Intervals) {
        this.startX = x;
        this.dates = Intervals;
        this.gantt.layers.date.innerHTML = '';
        this.gantt.layers.grid.innerHTML = '';
        this.gantt.layers.progress.innerHTML = '';
        this.gantt.layers.details.innerHTML = '';
        this.renderHeader();
        this.renderTask();
    }

    renderUpperText(date, x, x1) {
        if (date.upper_text) {
            createSVG('text', {
                x: x,
                y: date.upper_y,
                innerHTML: date.upper_text,
                class: 'upper-text',
                append_to: this.gantt.layers.date
            });
        }
        createSVG('line', {
            x1: x1,
            y1: 0,
            x2: x1,
            y2: 36,
            class: 'row-line thick',
            append_to: this.gantt.layers.date
        });
    }

    calculateQuarterly(Quarterly) {
        switch (Quarterly) {
            case quarterly_names[lang][0]:
                return 1;
            case quarterly_names[lang][1]:
                return 2;
            case quarterly_names[lang][2]:
                return 3;
            case quarterly_names[lang][3]:
                return 4;
            default:
                return 1;
        }
    }

    getNextEndDate(start, mode) {
        let result = null;
        let n = this.dates.length;
        //季度使用
        let st = this.dates[start].date.getMonth();
        let endt = 2;
        if (st <= 2) {
            endt = 2;
        } else if (st <= 5) {
            endt = 5;
        } else if (st <= 8) {
            endt = 8;
        } else if (st <= 11) {
            endt = 11;
        }
        for (let i = start || 0; i < n; i++) {
            let date = this.dates[i];
            switch (mode) {
                case 'Hour': {
                    if (date.lower_text == '23:00') {
                        result = date;
                        return result;
                    }
                    break;
                }
                case 'Day': {
                    let day = date_utils.get_days_in_month(
                        new Date(
                            ...[
                                date.date.getFullYear(),
                                date.date.getMonth(),
                                date.date.getDate()
                            ]
                        )
                    );
                    if (date.lower_text == day) {
                        result = date;
                        return result;
                    }
                    break;
                }
                case 'Week': {
                    if (date.lower_text == '日') {
                        result = date;
                        return result;
                    }
                    break;
                }
                case 'Month': {
                    if (date.lower_text == 12) {
                        result = date;
                        return result;
                    }
                    break;
                }
                case 'Quarterly Month': {
                    if (date.date.getMonth() == endt) {
                        result = date;
                        return result;
                    }
                    break;
                }
                case 'Quarterly': {
                    if (date.lower_text == quarterly_names[lang][3]) {
                        result = date;
                        return result;
                    }
                    break;
                }
                default: {

                }
            }
        }
        if (result == null) {
            result = this.dates[this.dates.length - 1];
        }
        return result;
    }

    getUpperTextOffset(date, allWidth, leftpos, first) {
        let column_width = this.gantt.options.column_width;
        let content_width = this.gantt.$task_content.offsetWidth;
        let upper_x = 0;
        let upper_x1 = 0;
        upper_x1 = leftpos + allWidth;
        if (upper_x1 < column_width) date.upper_text = '';

        if (first) {
            if (leftpos + allWidth > content_width) {
                //首个位置 超过可见范围
                // console.log(
                //     '---------------首个位置 超过可见范围----------------'
                // );
                upper_x = content_width / 2;
            } else {
                // console.log(
                //     '---------------首个位置 没有超过可见范围----------------'
                // );
                upper_x = upper_x1 / 2;
            }
        } else {
            if (upper_x1 > content_width) {
                // console.log(
                //     '---------------超过可见范围----------------'
                // );
                if (content_width - leftpos > column_width) {
                    upper_x = leftpos + (content_width - leftpos) / 2;
                } else {
                    date.upper_text = '';
                }
            } else {
                if (upper_x1 - leftpos > column_width) {
                    upper_x = leftpos + (upper_x1 - leftpos) / 2;
                } else {
                    date.upper_text = '';
                }
                // console.log(
                //     '---------------没有超过可见范围----------------'
                // );
            }
        }
        return {
            x: upper_x,
            x1: upper_x1,
            date: date
        }
    }

    renderHeader() {
        let n = this.dates.length;
        let column_width = this.gantt.options.column_width;
        let content_width = this.gantt.$task_content.offsetWidth;
        // console.log('renderHeader', this.dates[0].x1, this.startX );

        //暂时预留 2022 03 10
        // createSVG('rect', {
        //     x: 0,
        //     y: 0,
        //     width: parseInt(this.gantt.$svg.style.width),
        //     height: 74,
        //     class: 'bsy-gantt-date',
        //     append_to: this.gantt.layers.date
        // });


        for (let i = 0; i < n; i++) {
            let date = this.dates[i];

            createSVG('text', {
                x: date.lower_x - this.startX,
                y: date.lower_y,
                innerHTML: date.lower_text,
                class: 'lower-text',
                append_to: this.gantt.layers.date
            });

            createSVG('line', {
                x1: date.x1 - this.startX,
                y1: 36,
                x2: date.x1 - this.startX,
                y2: 72,
                class: 'row-line',
                append_to: this.gantt.layers.date
            });
            let leftpos = date.x1 - this.startX;
            let upper_x = 0;
            let upper_x1 = 0;
            switch (this.gantt.options.view_mode) {
                case 'Hour': {
                    if (i == 0 || date.lower_text == '00:00') {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );
                        let offset =
                            enddate.date.getHours() - date.date.getHours() + 1;
                        let allWidth = column_width * offset;
                        if (offset < 3) {
                            date.upper_text = '';
                            upper_x1 =
                                date.x1 + column_width * offset - this.startX;
                            this.renderUpperText(date, upper_x, upper_x1);
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                case 'Half Day': {
                    if (i == 0 || date.lower_text == am[lang]) {
                        if (date.lower_text == am[lang]) {
                            upper_x1 = date.x1 + column_width * 2 - this.startX;
                            upper_x = date.x1 + column_width - this.startX;
                        } else {
                            upper_x1 = date.x1 + column_width - this.startX;
                            date.upper_text = '';
                        }
                        this.renderUpperText(date, upper_x, upper_x1);
                    }
                    break;
                }
                case 'Year': {
                    if (i == 0 || date.lower_text == H2[lang]) {
                        if (date.lower_text == H2[lang]) {
                            upper_x1 = date.x1 + column_width * 2 - this.startX;
                            upper_x = date.x1 + column_width - this.startX;
                        } else {
                            upper_x1 = date.x1 + column_width - this.startX;
                            date.upper_text = '';
                        }
                        this.renderUpperText(date, upper_x, upper_x1);
                    }
                    break;
                }
                case 'Day': {
                    if (i == 0 || date.lower_text == 1) {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );

                        let offset =
                            enddate.date.getDate() - date.date.getDate() + 1;
                        //当前分类的占宽
                        let allWidth = column_width * offset;
                        if (offset < 3) {
                            date.upper_text = '';
                            upper_x1 =
                                date.x1 + column_width * offset - this.startX;
                            this.renderUpperText(date, upper_x, upper_x1);
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                case 'Week': {
                    if (i == 0 || date.lower_text == '一') {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );
                        let start =
                            date.date.getDay() == 0 ? 7 : date.date.getDay();
                        let end =
                            enddate.date.getDay() == 0 ?
                            7 :
                            enddate.date.getDay();
                        let offset = end - start + 1;
                        let allWidth = column_width * offset;
                        if (offset < 5) {
                            date.upper_text = '';
                            upper_x1 =
                                date.x1 + column_width * offset - this.startX;
                            this.renderUpperText(date, upper_x, upper_x1);
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                case 'Month': {
                    if (i == 0 || date.lower_text == 1) {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );
                        let offset =
                            enddate.date.getMonth() - date.date.getMonth() + 1;

                        //当前分类的占宽
                        let allWidth = column_width * offset;
                        if (offset < 1) {
                            date.upper_text = '';
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                case 'Quarterly Month': {
                    if (
                        i == 0 ||
                        date.lower_text == 1 ||
                        date.lower_text == 4 ||
                        date.lower_text == 7 ||
                        date.lower_text == 10
                    ) {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );
                        let offset =
                            enddate.date.getMonth() - date.date.getMonth() + 1;

                        //当前分类的占宽
                        let allWidth = column_width * offset;
                        if (offset < 1) {
                            date.upper_text = '';
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                case 'Quarterly': {
                    if (i == 0 || date.lower_text == quarterly_names[lang][0]) {
                        let enddate = this.getNextEndDate(
                            i,
                            this.gantt.options.view_mode
                        );
                        let offset =
                            this.calculateQuarterly(enddate.lower_text) -
                            this.calculateQuarterly(date.lower_text) +
                            1;

                        //当前分类的占宽
                        let allWidth = column_width * offset;
                        if (offset < 1) {
                            date.upper_text = '';
                        } else {
                            let upperOffset = this.getUpperTextOffset(
                                date,
                                allWidth,
                                leftpos,
                                i == 0
                            );
                            this.renderUpperText(
                                upperOffset.date,
                                upperOffset.x,
                                upperOffset.x1
                            );
                        }
                    }
                    break;
                }
                default: {

                }
            }
            // const $thick = createSVG('line', {
            //     x1:
            //         date.upper_x1 ||
            //         date.upper_x + date.upper_padding + offsetx,
            //     y1: 0,
            //     x2:
            //         date.upper_x1 ||
            //         date.upper_x + date.upper_padding + offsetx,
            //     y2: 36,
            //     class: 'row-line thick',
            //     append_to: this.layers.date
            // });
        }
        createSVG('line', {
            x1: 0,
            y1: 36,
            x2: content_width,
            y2: 36,
            class: 'row-line',
            append_to: this.gantt.layers.date
        });

        createSVG('line', {
            x1: 0,
            y1: 72,
            x2: content_width,
            y2: 72,
            class: 'row-line',
            append_to: this.gantt.layers.date
        });
    }

    renderTask() {
        let n = this.dates.length;
        let line_height =
            this.gantt.options.bar_height + this.gantt.options.padding;
        let tick_height = line_height * this.gantt.tasks.length;
        let todays = new Date();
        for (let i = 0; i < n; i++) {
            let date = this.dates[i];
            if(this.gantt.view_is(['Week', 'Day', 'Half Day'])) {

                if(date.date.getFullYear() == todays.getFullYear() 
                && date.date.getMonth() == todays.getMonth()  
                && date.date.getDate() == todays.getDate() ) {
                    let x = date.x1 - this.startX;
                    let y = 0;
                    let width = this.gantt.options.column_width;
                    let height = tick_height;
                    createSVG('rect', {
                        x: x,
                        y: y,
                        width: width,
                        height: height,
                        class: 'today-highlight',
                        append_to: this.gantt.layers.grid
                    });
                    y = 36;
                    height = 36;
                    createSVG('rect', {
                        x: x,
                        y: y,
                        width: width,
                        height: height,
                        class: 'today-highlight',
                        append_to: this.gantt.layers.date
                    });
                } else {
                    if ((date.week == 0 || date.week == 6)   ) {
                        let x = date.x1 - this.startX;
                        let y = 0;
                        let width = this.gantt.options.column_width;
                        let height = tick_height;
                        createSVG('rect', {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            class: 'weekend-highlight',
                            append_to: this.gantt.layers.grid
                        });
                        y = 36;
                        height = 36;
                        createSVG('rect', {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            class: 'weekend-highlight',
                            append_to: this.gantt.layers.date
                        });
                    }
                }
            }
 

            createSVG('line', {
                x1: date.x1 - this.startX,
                y1: 0,
                x2: date.x1 - this.startX,
                y2: tick_height,
                class: 'row-line',
                append_to: this.gantt.layers.grid
            });
        }

        let n1 = this.gantt.tasks.length;
        for (let i = 0; i < n1; i++) {
            createSVG('line', {
                x1: 0,
                y1: (i + 1) * line_height,
                x2: this.gantt.$task_content.offsetWidth,
                y2: (i + 1) * line_height,
                class: 'row-line',
                append_to: this.gantt.layers.grid
            });
        }
    }
}